<div class="p-6">
  <h2 class="text-xl font-bold">
    {{ 'ADDBALANCE.TITLE' | translate }}
  </h2>

  <form (ngSubmit)="enviarRecarga()" class="flex flex-col gap-4 mt-4">
    <!-- Monto -->
    <label>
      {{ 'ADDBALANCE.AMOUNT' | translate }}
      <input type="number" [(ngModel)]="monto" name="monto" class="border p-2 w-full" />
    </label>

    <!-- Motivo -->
    <label>
      {{ 'ADDBALANCE.REASON' | translate }}
      <select [(ngModel)]="motivo" name="motivo" class="border p-2 w-full">
        <option value="">{{ 'ADDBALANCE.SELECT_REASON' | translate }}</option>
        <option *ngFor="let m of motivos" [value]="m">
          {{ 'ADDBALANCE.REASONS.' + m | translate }}
        </option>
      </select>
    </label>

    <!-- Botón -->
    <button type="submit" class="bg-blue-600 text-white py-2 px-4 rounded">
      {{ 'ADDBALANCE.BUTTON' | translate }}
    </button>
  </form>
</div>
